import { SOAP_NOTE_GENERATION_STATUS } from "~/providers/constants/soapNoteGenerationStatus";
import { PatientSoapNote } from "~/providers/utils/types/zoomMeetingTypes";

export const isSoapNoteGenerationPending = (soapNote: PatientSoapNote) => {
  if (soapNote.completed_at) {
    return false;
  }

  return (
    soapNote.ai_generation_status === SOAP_NOTE_GENERATION_STATUS.pending ||
    soapNote.ai_generation_status === SOAP_NOTE_GENERATION_STATUS.in_progress
  );
};

export const isSoapNoteGenerationFailed = (soapNote: PatientSoapNote) =>
  soapNote.ai_generation_status === SOAP_NOTE_GENERATION_STATUS.failed;
